import { render, staticRenderFns } from "./PatientHeaderLayout.vue?vue&type=template&id=72157380"
import script from "./PatientHeaderLayout.vue?vue&type=script&lang=js"
export * from "./PatientHeaderLayout.vue?vue&type=script&lang=js"
import style0 from "./PatientHeaderLayout.vue?vue&type=style&index=0&id=72157380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports